// src/ecrans/accueil/accueil-remplissage.js — « Remplissage » de l'Accueil
// (maquette NEST v819) : les 30 prochains jours, une frise par logement.
//
// Lu depuis `ecran_calendrier_sejours_lire` { du: aujourd'hui, au: +30 } et
// `ecran_logements_lire`. Les chiffres du parc (% rempli, nuits libres) sont
// ceux du Calendrier (`chiffresMois`, une seule façon de compter) et suivent
// la règle des chiffres (src/ecrans/couverture.js) : seuls les logements
// SUIVIS comptent. AUCUN MONTANT : pas de « € réservés » (chemin d'argent).

import { chiffresMois, estAnnule, joursEntre } from "../calendrier/calendrier-calculs";
import { plateformeDe } from "../nest";
import { etatSuivi, idsNonSuivis } from "../couverture";

/** La plateforme qui occupe chaque nuit d'un logement (null = libre). */
export function nuitsDuLogement(id, sejours, jours) {
  const actifs = (sejours || []).filter((s) => s && s.logement && s.logement.id === id && !estAnnule(s));
  return jours.map((d) => {
    const s = actifs.find((x) => x.arrivee <= d && d < x.depart);
    return s ? plateformeDe(s.source, s.type) : null;
  });
}

/**
 * Le remplissage des 30 prochains jours. Rend null si une entrée manque.
 * `parc` : { rempli, libres } sur les logements suivis (null si aucun) ;
 * `lignes` : une par logement, les suivis du moins rempli au plus rempli,
 * puis les non suivis (leur pourcentage n'est pas su : null) ;
 * `parJour` : la part du parc suivi occupée chaque nuit (null si aucun suivi).
 * Couverture INCONNUE (lecture, échec, repli configuration) : on ne sait pas
 * quels logements sont suivis → aucun pourcentage par logement, pas de « plus
 * libre », pas de `parJour` (la règle des chiffres, ../couverture.js).
 */
export function remplissage({ logements, sejours, du, au, couverture }) {
  if (!Array.isArray(logements) || !Array.isArray(sejours)) return null;
  const jours = joursEntre(du, au);
  const connue = etatSuivi(couverture) !== null;
  const exclus = idsNonSuivis(couverture);
  const parc = chiffresMois({ logements, sejours, du, au, exclus });
  const lignes = logements.map((l) => {
    const suivi = connue && !exclus.has(l.id);
    const c = chiffresMois({ logements: [l], sejours, du, au });
    return {
      id: l.id,
      nom: l.nom || l.id,
      suivi,
      connue,
      rempli: suivi && c ? c.rempli : null,
      nuits: nuitsDuLogement(l.id, sejours, jours),
    };
  });
  const suivis = lignes.filter((l) => l.suivi);
  const parJour = suivis.length
    ? jours.map((_, i) => suivis.filter((l) => l.nuits[i] && l.nuits[i] !== "ferme").length / suivis.length)
    : null;
  const ordre = [
    ...suivis.sort((a, b) => (a.rempli ?? 0) - (b.rempli ?? 0) || String(a.nom).localeCompare(String(b.nom))),
    ...lignes.filter((l) => !l.suivi),
  ];
  return { jours, parc, lignes: ordre, parJour, plusLibre: suivis.length ? ordre[0] : null };
}
